export default "__VITE_ASSET__74f79dbe__"